import enLocale from 'element-ui/lib/locale/lang/en'
export default {
    ...enLocale,
    logs: {
        processor: "Processor and memory information",
        custom_list_prompts: "The current data is refreshed once every minute. The red number represents new data。",
        immediate_delivery: 'immediate_delivery',
        transmit: 'transmit',
        menu_judge: 'directory',
        // 携程单独配置
        ctrip1: 'Enable body malicious hyperlink protection',
        ctrip2: 'Isolated access to domain name',
        ctrip3: 'IP /Segment',
        ctrip4: 'Email or IP ',
        // 携程单独配置  end 

        // 域管理员 (代理商)
        domain_1: 'Expired Date',
        domain_2: 'Owner',
        domain_3: 'Domain List',
        domain_4: 'New Domain',
        domain_5: 'Editing Domain',
        domain_6: 'Domain Query',
        domain_7: 'Create Date Range',
        domain_8: 'Expired Date Range',
        domain_9: 'Change DomainName',
        domain_10: 'Original DomainName',
        domain_11: 'Change DomainAgent',
        domain_12: 'Set MailMove',


        agent2: 'Agent',
        agent3: 'Used/Available domain',
        agent4: 'Used/Available quota',
        agent5: 'Used/Available users',
        agent6: 'Used/Available netdisk',
        agent7: 'Create Agent',
        agent8: 'Agent Nick Name',
        agent9: 'Max Domain',
        agent10: 'Contact',
        agent11: 'Note',
        agent12: 'Website',
        agent13: 'Right Control ',
        agent14: 'Allow Deletion Of Fields',
        agent15: 'Allows Setting Attachment Size',
        agent16: 'Add Domain Space,User,Etc',
        agent17: 'Reduce Domain Space,Etc ',
        agent18: 'Secure E-mail',
        agent19: 'Address Book',
        agent20: 'Voice Mail',
        agent21: 'Video Mail',
        agent22: 'SMS',
        agent23: 'MMS',
        agent24: 'WAP',
        agent25: 'Print',
        agent26: 'Email Monitoring',
        agent27: 'Mailing List',
        agent28: 'Sub-agents',
        agent29: 'POP3',
        agent30: 'Domain Alias List',
        agent31: 'Adding Domain Alias',
        agent32: 'Domain Alias',
        agent33: 'Target Domain',
        // 域管理员 (代理商) end


        // 域管理员 (用户)
        // 管理模式
        mode_switch1: 'Mode Switch',
        mode_switch2: 'The current mode',
        mode_switch3: 'Admin password',
        mode_switch4: 'quarantine	',
        mode_switch5: 'normal email',
        mode_switch6: 'log query	',
        mode_switch7: 'policy',
        mode_switch8: 'audit',
        mode_switch100: 'ReadOnly',
        mode_switch9: 'Sets Role Management Object',
        mode_switch91: 'sets role management object',
        mode_switch92: 'This role manages the department',

        mode_switch10: 'roles to users',
        mode_switch11: 'this role manages users',
        mode_switch12: 'Role Member',
        mode_switch13: 'User Settings',
        mode_switch14: 'Ordinary user default',
        mode_switch15: 'Sets whether ordinary users log into the admin',
        mode_switch16: 'User List',
        mode_switch17: 'User type',
        mode_switch18: 'Login type',

        // 管理模式 end 
        // 角色管理
        role1: 'Role List',
        role2: 'role name',
        role3: 'Add Role',
        role4: 'Set Boss',
        role5: 'Modify Role',
        role6: 'Role Permission Settings',
        role7: 'view mail snap',
        role8: 'check normal email',
        role9: 'download normal mail',
        role10: 'normal recover',
        // 定制管理
        customize1: 'Interface Customize',
        customize2: 'Index page url',
        customize3: 'Logout page url',
        customize4: 'logo img',
        customize5: 'Advertising Custom',
        customize6: 'set advertisement attatched in message while writing',
        customize7: 'HTML code',
        customize8: 'TEXT',
        customize9: '内容',
        // 定制管理 end 
        // 监控列表
        monitor_list1: 'Monitor List',
        monitor_list2: 'Monitored Object',
        monitor_list3: 'Account For Backup',
        monitor_list4: 'Add Monitor ',
        monitor_list5: 'Edit Monitor List',
        // 监控列表 end

        // 别名列表
        alias_list1: 'Alias List',
        alias_list2: 'Alias',
        alias_list3: 'Goto Address',
        alias_list4: 'Add Alias',
        alias_list5: 'Edit Alias List',
        // 别名列表 end
        // 邮件限制列表
        mail_limit1: 'List Mail Limit',
        mail_limit2: 'Add Mail Limit',
        mail_limit3: 'Limited User',
        mail_limit4: 'Limit Send',
        mail_limit5: 'Limit Rcv',
        mail_limit6: 'Edit Mail Limit',
        mail_limit7: 'Advanced',
        mail_limit8: 'only include',
        mail_limit9: 'exclude',
        // 邮件限制列表 end
        // 群发邮件
        group_sending1: 'Explain',
        group_sending2: 'send',
        group_sending3: 'all users',
        group_sending4: 'designated department',
        group_sending5: 'Group Sending',
        // 群发邮件 end
        // 邮件管理
        mail_list1: 'Mail List',
        mail_list2: 'New Mail List',
        mail_list3: 'Edit Mail List',
        mail_list4: 'mailList Type',
        mail_list5: 'mailList Admin',
        mail_list6: 'Authorized Users',
        mail_list7: 'Add an internal mailbox',
        mail_list8: 'Add External Mailboxes',
        mail_list9: 'Increase the department',
        // 邮件管理  end

        // 创建用户
        create_user1: "Create User",
        create_user2: "Gender",
        create_user3: "Whether the VIP",
        create_user4: "Disable Rules",
        create_user5: "Duty",
        create_user6: "Job Number",
        create_user7: "Password query problem",
        create_user8: "Query password answer",
        create_user9: "Last Login Time",
        create_user10: "Last Login IP",
        create_user11: "Base Info",
        create_user12: "Company",
        create_user13: "Special Plane",
        create_user14: "Province",
        create_user15: "City",
        create_user16: "Mobile Phone",
        create_user17: "Fax",
        create_user18: "Postcode",
        create_user19: "Address",
        create_user20: "Upload and create users",
        // 创建用户 end

        // 用户管理
        user_list_manage1: 'MaxAccount',
        user_list_manage2: 'AssignedAccount',
        user_list_manage3: 'LeftAccount',
        user_list_manage4: 'MaxSpace',
        user_list_manage5: 'AssignedSpace',
        user_list_manage6: 'LeftSpace',
        user_list_manage7: 'Maxnetdisk(M)',
        user_list_manage8: 'AssignedNetdisk',
        user_list_manage9: 'LeftNetdisk',
        user_list_manage10: 'delete in batches',
        user_list_manage11: 'Assign to depart:',
        user_list_manage12: 'active account',
        user_list_manage13: 'disable account',
        user_list_manage14: 'Cancel Admin',
        user_list_manage15: 'Set Admin',
        // 用户管理 end
        // 公告管理
        notice: 'AnnounceList',
        notice1: 'Subject',
        notice2: 'Type',
        notice3: 'Publisher',
        notice4: 'Date',
        notice5: 'New Announcement',
        notice6: 'Subject',
        notice7: 'Body',
        notice8: 'Edit Announcement',
        // 公告管理 end
        // 部门管理
        depart1: 'List Depart',
        depart2: 'Business Enterprise',
        depart3: 'Level',
        depart4: 'User Number',
        depart5: 'Depart NO',
        depart6: 'download depart excel',
        depart7: 'Superior Department',
        depart8: 'Name',
        depart9: 'Quota(M)',
        depart10: 'User ID',
        depart11: 'Add Depart',
        depart12: 'look',
        depart13: 'Depart User List  ',
        depart14: 'Depart Structure',
        depart15: 'Identity',
        depart16: 'Sort field',
        depart17: 'Sort order ',
        depart18: 'Active',
        // 部门管理 end
        // 域管理员 (用户) end




        // 大系统

        url_a1_xie: 'Domain Whitelist',
        url_a2_xie: 'White list of IP',
        url_a3_xie: 'stair domain',
        url_a4_xie: 'Into the list',
        url_a5_xie: 'Nontransformed list',
        url_a6_xie: 'Global transformation',
        url_a7_xie: 'Global nontransformation',
        point: 'mark',
        second_rate: 'next',
        as_good: 'As_good',
        as_spam: 'As_spam',
        derived: 'nums',
        up_mail: 'This is the first email',
        next_mail: 'This is the last email',

        up_mail1: 'Prev',
        next_mail1: 'Next',
        // 首页
        zhu_info3_1: 'virus',
        zhu_info3_2: 'fish',
        zhu_info3_3: 'eroticism',
        zhu_info3_4: 'other',
        zhu_info3_5: 'advertising',
        zhu_info3_6: 'politics',
        zhu_info3_7: 'sum',

        zhu_info2_1: 'receipt',
        zhu_info2_2: 'send',

        zhu_info1_1: 'mail',
        zhu_info1_2: 'intercept',
        zhu_info1_3: 'connect',
        zhu_info1: 'Mail statistics',
        zhu_info2: 'Receiver chart',
        zhu_info3: 'Refuse sorting',
        zhu_info4: 'CPU figure',
        welcome: 'Welcome to login ！',
        out_login: 'login out',
        time_login: 'time out',
        time_login2: 'overtime(>=5min)',
        time_login1: 'Set time out',
        time_login3: 'minimum time 5 minutes',
        // URL隔离模块配置
        url_a1: 'URL isolation whitelist',
        url_a2: 'Enable URL isolation',
        url_a3: 'Quarantine add URL',
        url_a4: 'URL or IP address',
        url_a5: 'URL isolation default policy',

        sender_query: 'Sender Query',
        sender_query1: 'Receiver Query',
        Relay_target: 'Relay Target',
        // tls 策略管理
        tls_policy1: "Whether to enable mandatory TLS",
        tls_policy2: "Enforces the TLS default policy",
        tls_policy3: "Forced the TLS",
        // 系统信息
        sysyem_menu1: 'Disk Status',
        sysyem_menu2: 'System Process',
        sysyem_menu3: 'CPU and Memory info',
        sysyem_menu4: 'Version Update',
        sysyem_menu5: 'Rule Manage',
        sysyem_menu6: 'History Info',
        // 管理员列表
        user_list1: 'Manager List',
        user_list2: 'Manager',
        user_list3: 'Super Manager',
        user_list4: 'Add Manager ',
        user_list5: 'Relation Email',
        user_list6: 'Password',
        user_list7: 'Confirm Password',
        user_list9: 'Edit Manager',
        user_list8: 'Allow Ip',
        shouye: 'Home',
        // 归档管理  归档委派
        delegata1: "Delegate List",
        delegata2: "Delegate To",
        delegata3: "Add Delegate",
        delegata3_edit: "Edit Delegate",
        // 策略组配置  策略优先级
        policyorder1: 'Policy priority',
        policyorder2: 'Policy priority',
        policyorder3: 'Policy Name',
        policy_matchcn: 'Match Num',
        // 策略组配置  组级策略
        group1: 'Group policy',
        group2: 'All regex',
        group3: 'All in pol',
        group4: 'All out pol',
        group5: 'Add Group',
        group6: 'Group Name',
        group7: 'Domain policy',
        group7_c1: 'Domain Name',
        group7_c2: 'Domain',
        group1_a1: 'Group Member  ',
        group1_a2: 'Group Rule ',
        group1_c2: 'Domain Rule ',
        group1_e2: 'Email Rule ',
        group1_a3: 'Group In Pol',

        group1_c3: 'Domain In Pol',
        group1_e3: 'Email In Pol',
        group1_a4: 'Group Out Pol ',
        group1_c4: 'Domain Out Pol ',
        group1_e4: 'Email Out Pol ',
        domain1: 'Input Query Domain',
        userLevel: 'UserLevel Policy',
        userLevel1: 'Add Policy Users',
        userLevel2: 'Policy Users',
        userLevel3: 'Users',



        group7_a1: 'Group',
        group7_a2: 'Group depart',
        group7_a3: 'Group email',
        group7_a4: 'domain',
        group7_a5: 'Depart',
        group7_a6: 'Inculude Sub Depart',
        group7_a7: 'Domain',
        group7_a8: 'Both',
        group7_a9: 'Default',
        group7_a11: 'In',
        group7_a12: 'Out',
        group7_a15: 'Standby',
        group7_a16: 'Poll',
        group7_b1: 'Group Filter',
        group7_b2: 'Group IP White',
        group7_b3: 'Group IP Black',
        group7_b4: 'Group From White',
        group7_b5: 'Group From Black',
        group7_b6: 'Add Group Filter',
        group7_b7: 'Add Group IP White',
        group7_b8: 'Add Group IP Black',
        group7_b9: 'Add Group From White',
        group7_b10: 'Add Group From Black',
        group7_ba1: 'Domain Filter',
        group7_ba2: 'Domain IP White',
        group7_ba3: 'Domain IP Black',
        group7_ba4: 'Domain From White',
        group7_ba5: 'Domain From Black',
        group7_ba6: 'Add Domain Filter',
        group7_ba7: 'Add DomainIP White',
        group7_ba8: 'Add Domain IP Black',
        group7_ba9: 'Add Domain From White',
        group7_ba10: 'Add Domain From Black',
        group7_bc1: 'User Filter',
        group7_bc2: 'User IP White',
        group7_bc3: 'User IP Black',
        group7_bc4: 'User From White',
        group7_bc5: 'User From Black',
        group7_bc6: 'Add User Filter',
        group7_bc7: 'Add User IP White',
        group7_bc8: 'Add User IP Black',
        group7_bc9: 'Add User From White',
        group7_bc10: 'Add User From Black',
        // 反垃圾配置  暗送配置
        bcc1: 'Bcc List',
        bcc2: 'Add Bcc',
        bcc2_edit: 'Edit Bcc',
        bcc3: 'Bcc Source ',
        bcc4: 'Bcc Type',
        bcc5: 'Bcc Taget ',
        // 反垃圾配置  代理管理i
        proxy1: 'Proxy parameter',
        proxy2: 'Enable web proxy',
        proxy3: 'Web proxy use port',
        proxy4: 'Web proxy server address',
        proxy5: 'Enable pop proxy',
        proxy6: 'Pop proxy use port',
        proxy7: 'Pop proxy server port',
        proxy8: 'Pop proxy server adress',
        proxy9: 'Enable imap proxy',
        proxy10: 'Imap proxy use port',
        proxy11: 'Imap proxy server port',
        proxy12: 'Imap proxy server address',
        // 反垃圾配置  SNMP
        snmp1: 'SNMP Parameter',
        snmp2: 'Source',
        snmp3: 'Community',
        // 反垃圾配置  APT
        apt1: 'Sandbox Switch',
        apt2: 'Sandbox Device',
        apt3: 'max msg size of Sandbox scan',
        apt4: 'Only scan below the maximum size,It is not recommended to scan over 20M',
        apt5: 'Enable Apt check',
        apt6: 'Enable Sandbox scan to analyze malicious urls, short urls and malicious attachments',
        apt7: 'Sandbox mode View',
        apt8: 'In Sandbox observation mode, the mail will not wait for Sandbox scan,',
        apt9: 'Device Login User',
        apt10: 'Userpassword',
        apt11: 'Device ID',
        apt12: 'Device IP Addr',
        apt13: 'Sandbox Port',
        // 反垃圾配置  DKIM 和 DMARC
        dkim1: 'Sign Param',
        dkim2: 'DKIM Domain List',
        dkim3: 'DKIM Trust Host',
        dkim1_a1: 'DKIM Sign',
        dkim1_a2: 'Signing Of DKIM With The Configure Domains',
        dkim1_a3: 'DKIM Verify',
        dkim1_a4: 'Verify Of DKIM With The Out Of Senders',
        dkim1_a5: 'DMARC Verify',
        dkim1_a6: 'Verify Of DMARC,When Enable DMARC Verify Must Enable DKIM Verify',
        dkim1_a7: 'Add Domain Key',
        dkim1_a8: 'Sign Domain',
        dkim1_a9: 'DKIM Selector',
        dkim1_a10: 'Sign Key Value',
        dkim1_a11: 'Add Trust Host',
        dkim1_a12: 'DKIM Trust Host',
        tempalte_adm: 'template management',
        tempalte_adm_name: 'template name',
        tempalte_adm_notify: 'notify the theme',
        tempalte_adm_content: 'inform the content',
        tempalte_adm_acc: 'the original email is attached',
        tempalte_adm_add: 'add template management',
        tempalte_adm_edit: 'edit template management',
        // 反垃圾配置  灰名单管理
        greylist1: 'Greylist Setting',
        greylist2: 'Enable Greylist',
        greylist3: 'Greylist Server Timeout',
        // 反垃圾配置  附件解析管理
        attachment1: 'Attachment resolution setting',
        attachment2: 'Enable attach resolution',
        attachment3: 'The number of attachments resolved',
        attachment4: 'Attach resolution timeout(s)',
        attachment5: 'Attach resolution max attachment size(KB)',
        attachment6: 'Attach resolution max message size(KB)',
        attachment7: 'Attach resolution max attach num',
        attachment8: 'Sets the number of the first few attachments in the resolved message',
        attachment9: 'Set the time when resolution attachment fail',
        attachment10: 'When the signle attachment size greater than the set,it will not resolution with the attachment',
        attachment11: 'When the message size greater than the set,it will not resolution',
        attachment12: 'When the attach num in message greater than the set,it will not resolution',
        // 反垃圾配置  智能学习管理
        smartLearn1: 'Greylist setting',
        smartLearn2: 'filter setting',
        smartLearn3: 'Normal list',
        smartLearn4: 'Spam list',
        smartLearn5: 'Enable smart learning',
        smartLearn6: 'Smart learning max message size(KB)',
        smartLearn7: 'Add Smart Learn Person',
        smartLearn8: 'Email Or Ip ',
        smartLearn9: 'Learn Normal email',
        smartLearn10: 'Learn about spam',
        snpm: 'SNMP Source',
        snpm1: 'SNMP Community',
        // 反垃圾配置  IP黑名单认证管控
        blackip1: 'Auth ip blacklist check',
        blackip2: 'Auth ip blacklist default policy',
        // 反垃圾配置  SMTP发信IP管控
        smtpIp1: 'Auth limit policy for user',
        smtpIp2: 'Permit auth IP',
        smtpIp3: 'Permit auth IP for user',
        smtpIp4: 'Auth limit default policy for user',
        smtpIp5: 'Add Smtp Policy For Email',
        smtpIp5_edit: 'Edit Smtp Policy For Email',
        smtpIp6: 'Type',
        smtpIp7: ' Add Permit Ip By Smtp',
        smtpIp7_edit: ' Edit Permit Ip By Smtp',
        smtpIp8: 'Add Permit auth IP for user',
        smtpIp8_edit: 'Edit Permit auth IP for user',
        smtpIp9: 'Account',
        // 反垃圾配置  异常及滥发管理
        abnorMal1: 'abnormal default',
        abnorMal2: 'weakpass default',
        abnorMal3: 'abnormal pol',
        abnorMal4: 'weakpass pol',
        abnorMal5: 'Weakpass lib',
        abnorMal6: 'Content abuse',
        abnorMal7: 'Edit Abnormal Default',
        abnorMal8: 'Check Type',
        abnorMal9: 'Check Value',
        abnorMal10: 'Edit Weakpass Default',
        abnorMal11: 'Type Hint',
        abnorMal12: 'Add Abnormal Pol',
        abnorMal12_edit: 'Edit Abnormal Pol',
        abnorMal13: 'Add Weakpass Pol',
        abnorMal13_edit: 'Edit Weakpass Pol',
        abnorMal14: 'Add Weakpass',
        abnorMal15: 'Bulk Add Weakpass',
        abnorMal16: 'Import Weakpass',
        abnorMal17: 'Export Weakpass',
        abnorMal18: 'Weak Password',
        abnorMal19: 'Add Abuse Pol',
        abnorMal19_edit: 'Add Abuse Pol',
        abnorMal20: 'Set Abuse Url',
        abnorMal21: 'Content abuse default action for user',
        abnorMal22: 'Spamming Num',

        // 反垃圾配置  ldap
        ldap1: 'Domain policy',
        ldap2: 'Domain action',
        ldap3: 'Userlist and set',
        ldap4: 'LDAP check user',
        ldap5: 'Ldap domain config',
        ldap6: 'Dictionary attack',
        ldap7: 'Input Query Domain',
        ldap8: 'Search',
        ldap9: 'Policy explain',
        ldap10: 'Rcpt chk policy',
        ldap11: 'Action explain',
        ldap12: 'Rcpt chk action',

        ldap13: 'Input Query User',
        ldap14: 'Add User',
        ldap14_edit: 'Edit User',
        ldap15: 'Batch Create Users',
        ldap16: 'Import Accounts From Flie',
        ldap17: 'LDAP check user',
        ldap18: 'Add LDAP Config',
        ldap18_edit: 'Edit LDAP Config',
        ldap19: 'Ldap host',
        ldap20: 'Verify',
        ldap21: 'edit',
        ldap22: 'Add Domain',
        ldap23: 'Domain',
        ldap24: 'Dictionary attack check',
        ldap25: 'If enable,will check the bad recipients',
        ldap26: 'Max bad recipients',
        ldap27: 'If rich the max bad recipients,will reject the sender',
        ldap28: ' wrong recipient',
        ldap29: 'incorrect recipients reached the maximum latency response time',
        ldap30: 'DMARC personalization strategy',

        ldap31: 'DMARC default check policy',
        ldap32: 'Add DMARC policy',
        ldap32_edit: 'Edit DMARC policy',
        ldap33: 'LDAP user synchronization',
        ldap34: 'Use LDAP recipient check configuration',
        ldap35: 'Manual sync',
        ldap36: 'Set Timing Sync',
        ldap37: 'Time points periodically',
        ldap38: 'LDAP user sync config',
        ldap39: 'Maximum wrong recipients per session',
        ldap40: 'Whether to reject when the number of wrong recipients in a single session reaches the set value,0 indicates no rejection',
        // 反垃圾配置  系统收发控制
        frequency1: 'SMTP frequency control',
        frequency1_add: 'Add free frequency limit IP',
        control1: 'Local Default',
        control2: 'Outer Default',
        control3: 'IP Default',
        control4: 'Set Local',
        control5: 'Set Outer',
        control6: 'Set IP',
        control7: 'Disable user',
        control8: 'Disable IP',
        control9: 'Edit Local User Default Control',
        control10: 'Control Type',
        control11: 'Control Number',
        control12: 'Edit Outside User Default Control',
        control13: 'Edit IP Default Control',
        control14: 'Set Control Of Local Email',
        control14_edit: 'Edit Control Of Local Email',
        control15: 'Set Control Of Out Email',
        control15_edit: 'Edit Control Of Out Email',
        control16: 'Set Control Of IP',
        control16_edit: 'Edit Control Of IP',
        control17: 'Add Prebl',
        control18: 'Add ip Prebl',
        // 反垃圾配置  个性化策略
        policy1: 'envfrom policy',
        policy2: 'envrcpt policy',
        policy3: 'connect policy',
        policy4: 'policy list',
        policy5: 'input envfrom or domain',
        policy6: 'Get Cur Policy Of Cur Object',
        policy7: 'filter policy',
        policy8: 'Description',
        policy9: 'default type',
        policy10: 'input envrcpt or domain',
        policy11: 'input connnect IP',
        policy12: 'filter type',
        policy13: 'setting object',
        policy14: 'check action',
        // 反垃圾配置  过滤器
        filter1: 'Filter List',
        filter2: 'Add Filter',
        filter3: 'Filter Name',
        filter4: 'Filter Describe',
        filter5: 'By used',
        filter6: 'Create Time',
        filter7: 'Update Time',
        filter8: 'Show Macro',
        filter9: 'Hide Macro',
        filter10: 'Edit Filter',

        Conditional1: 'Condition enable',
        Conditional2: 'And',
        Conditional3: 'Or',
        Conditional4: 'Condition',
        Conditional5: 'Add Condition',
        Conditional6: 'Delete Condition',
        Conditional7: 'Add',
        Conditional8: 'Delete',
        Conditional9: 'Rule relation',
        Conditional10: 'Rcpt in url',
        Conditional11: 'Condition check',
        Conditional12: 'Black url check',
        Conditional13: 'IP of url check',
        Content1: 'Content enable',
        Content2: 'Content',
        Content3: 'Add content',
        Content4: 'Delete content',
        Content5: 'Score',
        Alink1: 'Alink enable',
        Alink2: 'Alink',
        Alink3: 'Add alink',
        Alink4: 'Delete alink',
        // 反垃圾配置  组合策略
        // 反垃圾配置  组合策略
        Policy_unit: 'Policy unit',
        Policy_comb: 'Policy comb',
        Regex_test: 'Regex test online',
        disclaimer: "Disclaimer",
        disclaimer1: "Disclaimer content",
        disclaimer_new1: "disclaimer-html(UTF-8)",
        disclaimer_new2: "disclaimer-html(en_us)",
        disclaimer_new3: "disclaimer-plain(UTF-8)",
        disclaimer_new4: "disclaimer(en_us)",
        prompt_statement: 'risk warning',
        prompt_statement_show: ' default risk warning open',
        prompt_statement_table: 'risk warning open',
        hint_new1: "risk warning-html内容(UTF-8)",
        hint_new2: "risk warning-html内容(en_us)",
        hint_new3: "risk warning-plain内容(UTF-8)",
        hint_new4: "risk warning-plain内容(en_us)",
        disclaimer3: "Disclaimer content in pure English",
        disclaimer2: "Enable",
        disclaimer_daf: "Default Prompts enabled",
        disclaimer_daf1: "Personalized Prompts",
        disclaimer_daf1_add: "Add Personalized Prompts",
        disclaimer_daf1_daf: "Disclaimer enabled or not",
        disclaimer4: "Save whetherAdd",
        disclaimer5: "Local domainAdd",
        Policy_unit1: 'Add Policy unit',
        Policy_unit1_eidt: 'Edit Policy unit',
        Policy_unit2: 'Policy unit name must be set with letter or number and set only one type each unit',
        Policy_unit3: 'Policy unit type',
        Policy_unit4: 'Policy unit name',
        Policy_unit5: 'Remark explain',
        Policy_unit6: 'Rule relation',
        Policy_unit7: 'Rule num',
        Policy_unit8: 'By used',
        Policy_unit9: 'Create time',
        Policy_comb1: 'name',
        Policy_comb2: 'rule',
        Policy_comb3: 'direction',
        Policy_comb4: 'check action',
        Policy_comb5: 'active',
        Policy_comb6: 'center',
        Policy_comb7: 'inspect',
        Policy_comb8: 'Policy type',
        Policy_comb9: 'expire',
        Policy_comb_select: 'optional action',

        Policy_comb12: 'yes',
        Policy_comb13: 'no',
        Policy_comb11: 'Add Policy comb',
        Policy_comb11_edit: 'Edit Policy comb',
        Policy_comb10: 'Policy comb is to combine the units in and or non, to form a composite policy',
        Regex_test1: 'Input matching text',
        Regex_test2: 'regex',
        Regex_test3: 'Match result',
        Regex_test4: 'Text Match',
        Regex_test5: 'Antistop',
        // 过滤器 发件人
        to_envfrom_sender: 'Import the sender',
        export_envfrom_sender: 'Export the sender',
        to_envfrom_rec: 'Importing recipients',
        export_envfrom_rec: 'Export recipient',
        to_envfrom_ip: 'Import IP address',
        export_envfrom_ip: 'Export IP address',
        Policy_unit_sender1: 'Sender',
        Policy_unit_sender2: 'Add Sender',
        Policy_unit_sender3: '批量添加',
        Policy_unit_sender4: '添加单元内发件人列表，单元名称：usender,单元内规则关系:或',
        Policy_unit_sender5: 'Unit email or dn',
        Policy_unit_sender6: 'User type',
        Policy_unit_Recipient1: 'Recipient',
        Policy_unit_Recipient2: 'Add Recipient',
        Policy_unit_Recipient3: '添加单元内收件人列表，单元名称：urcpt,单元内规则关系:或',
        Policy_unit_ip1: 'IP Address',
        Policy_unit_ip2: 'Add ipaddr',
        Policy_unit_regex1: 'Regex',
        Policy_unit_regex2: 'Add Regex Rule',
        Policy_unit_regex2_edit: 'Edit Regex Rule',
        Policy_unit_regex3: 'Type',
        Policy_unit_regex4: 'Header key',
        Policy_unit_regex5: 'Unit regex fule',
        Policy_unit_regex6: 'Rule type',
        Policy_unit_rule: 'Condition rule config',
        Policy_unit_rule_msgsize: 'msgsize',
        Policy_unit_rule_bodysize: 'bodysize',
        Policy_unit_rule_attsize: 'attsize',
        Policy_unit_rule_attnum: 'attnum',
        Policy_unit_rule_rcptnum: 'rcptnum',
        Policy_unit_rule_outrcptnum: 'outrcptnum',
        Policy_unit_rule_bsrcptnum: 'bsrcptnum',
        Policy_unit_rule_bccnum: 'bccnum',
        Policy_unit_rule_Checkwhite: 'Check White',
        Policy_unit_rule_Timerange: 'Timerange',
        Policy_unit_rule_Checknettype: 'Check Net Type',
        Policy_unit_rule_Checkfrom: 'Check From',
        Policy_unit_url1: 'Url List',
        Policy_unit_url2: 'Add URL',
        Policy_unit_url3: 'Url IP',
        Policy_unit_url4: 'Add lP',
        Policy_back: 'Back',
        // 反垃圾配置  SPF配置
        spf1: 'Add SPF White IP',
        spf2: 'Import SPF White IP',
        spf3: 'Export SPF White IP',
        spf4: 'Add SPF White Email',
        spf5: 'Import SPF White Email',
        spf6: 'Export SPF White Email',
        spf8: 'SPF White Email',
        spf7: 'SPF White IP',
        // 反垃圾配置  过滤策略
        Policy_list1: 'Policy List',
        Policy_list_white: 'Super whitelist',

        Policy_list2: 'Add Policy',
        Policy_list17: 'Edit Policy',
        Policy_list3: 'Policy name',
        Policy_list4: 'filter',
        Policy_list5: 'Cassembly uni',
        Policy_list6: 'check action',
        Policy_list7: 'Remark explain',
        Policy_list8: 'direction',
        Policy_list9: 'Active',
        Policy_list10: 'Run on cente',
        Policy_list11: 'Offline disable',
        Policy_list12: 'Permit set nocheck',
        Policy_list13: 'Policy type',
        Policy_list14: 'priority',
        Policy_list15: 'expire',
        Policy_list16: 'Create time',
        Policy_list18: 'area distribution',
        Policy_list19: 'Authorized',
        Policy_list20: 'Sets manageable object',
        Policy_list21: 'Admin',
        Policy_list22: 'saveday(day)',
        Policy_list23: 'custom',
        Policy_list24: 'time',
        Policy_list25: 'mintue',
        strategy_group: "Strategy group",
        strategy_group_add: " Add Strategy group",
        strategy_group_edit: "Edit Strategy group",
        strategy_group_admin: "Strategy Group Management",
        strategy_group_admin_control: "For area mail power",
        Policy_list_son: 'New substrategy',
        Policy_list_son_edit: 'Edit substrategy',
        Policy_list_son_new: 'substrategy',

        policy_group_name: "Name of policy group",

        regional_authority: "Area management",
        regional_authority1: "Add area",
        // 6数据统计排行   报表及排程管理
        report1: 'Report Build',
        report2: 'Schedule Build',
        report3: 'Send',
        report4: 'Receiving',
        report5: 'Ranking',
        report6: 'Merge Data',
        report7: 'local Send',
        report8: 'Outer Send',
        report9: 'Local Domain Send',
        report10: 'Out Domain Send',
        report11: 'IP',
        report12: 'IP/24',
        report13: 'Selectall',
        report14: 'Other',
        report15: 'Print Numbers',
        report16: 'Download',
        report17: 'Email for receive',
        report18: 'Time',
        // 数据统计排行   规则匹配统计
        statRule1: 'Regex match',
        statRule2: 'Combine rule',
        statRule3: 'New rule',
        statRule1_a1: 'Regex type',
        statRule1_a2: 'Regex value',
        statRule1_a3: 'Regex score',
        statRule1_a4: 'Matchcn',

        statRule1_a6: 'Time of match',
        statRule1_a7: 'Combine rule',
        statRule1_a8: 'New rule',
        statRule1_a9: 'Policy type',
        statRule1_a10: 'Mtach or not',
        topic_statistical: ' Topic of statistical',
        topic_statistical_title: ' subject',
        // 数据统计排行   T统计报表
        loacalsendmsg1: 'Messages',
        loacalsendmsg2: 'Bigsites',
        loacalsendmsg3: 'Bytes',
        loacalsendmsg4: 'Recipients',
        loacalsendmsg5: 'Out messages',
        loacalsendmsg6: 'Out recipients',
        loacalsendmsg7: 'Out bytes',
        loacalsendmsg8: 'Outland mail count',
        loacalsendmsg9: 'From Bigsites',
        loacalsendmsg10: 'Outfield Bytes',
        loacalsendmsg11: 'Bounce',
        loacalsendmsg12: 'Reject',
        loacalsendmsg13: 'Connections',
        loacalsendmsg14: 'Auth success',
        loacalsendmsg15: 'Auth fail',
        loacalsendmsg1_a1: 'Number',
        loacalsendmsg1_a2: 'Update time',
        loacalsendmsg1_a3: '24 hours detail',
        loacalsendmsg1_a4: 'Senddetail',
        loacalsendmsg1_a8: 'Recivedetail',
        loacalsendmsg1_a5: 'Realtimelog',
        loacalsendmsg1_a6: 'Archive ',
        loacalsendmsg1_a7: 'Detail ',
        loacalsendmsg_a1: 'Show Num',
        loacalsendmsg_a2: 'Time Interval',
        // 数据统计排行   数据统计
        statistics1: 'Query for the last two years of global statistical data',
        statistics2: 'Download Statistics',
        statistics3: 'Time',
        statistics4: 'Connections',
        statistics5: 'Messages',
        statistics6: 'Total intercept',
        statistics7: 'Recipients',
        statistics8: 'Virus',
        statistics9: 'ip blacklist',
        statistics10: 'SPF Intercept',
        statistics11: 'Recipient unknown',
        statistics12: 'Bytes',
        statistics14: 'en_day_stat',
        statistics13: 'data statistics',
        statistics15: 'Subitem',
        statistics16: 'Total',
        statistics17: 'EVIL',
        statistics18: 'Fish ',
        statistics19: 'Regional Managem List',
        statistics_list: 'regional list',
        statistics20: 'List of Policy Details',
        statistics_table: 'Table shows',
        statistics_chart: 'Chart shows',
        // 系统配置   集群管理
        colony1: 'Colony master set',
        colony2: 'Colony minion set',
        colony3: 'Colony list',
        colony1_a1: 'Enabled colony master',
        colony1_a2: 'Enabled colony master,will unified management the minion hosts',
        colony1_a3: 'Colony master ipaddr',
        colony1_a4: 'The set ip is in local and interworking with the minion',
        colony2_a1: 'Enabled colony minion',
        colony2_a2: 'Enabled colony minion,will disable all config item',
        colony2_a3: 'Colony minion ipaddr',
        colony2_a4: 'The set ip is in local and interworking with the master',
        colony3_a1: 'Add minion host',
        colony3_a2: 'status',
        // 系统配置   补丁升级
        patch1: 'System Patch upgrade',
        patch2: 'Upload Patch',
        patch3: 'Patch upgrade',
        // 系统配置   系统服务
        system1: 'system Management Services',
        system2: 'system  Services',
        system3: 'status',
        system4: 'start',
        system5: 'stop',
        // 系统配置   配置双机热备
        HASetting1: 'HA Setting',
        HASetting2: 'Start HA',
        HASetting3: 'ucast addr',
        HASetting4: 'Set the broadcast address as the IP address of the other party',
        HASetting5: 'shift addr',
        HASetting6: 'Configure the outbound drift address and subnet mask at the service port',
        HASetting7: 'ping addr',
        HASetting8: 'Always set the network gateway by ping,can not set if two lines direct connect',
        HASetting9: 'master hostname',
        HASetting10: 'slave hostname',
        HASetting11: 'as master node',
        // 系统配置   配置防火墙
        firewall1: 'base policy',
        firewall2: 'Rules List',
        firewall1_a1: 'Start The Firewall',
        firewall1_a_2: 'Off The Firewall',
        firewall1_a1_a1: 'The Firewall Is Currently Closed',
        firewall1_a1_a2: 'The Firewall Is Currently On',
        firewall1_a2: 'Default Input',
        firewall1_a3: 'Default Output',
        firewall1_a4: 'Default Forward',
        firewall1_a5: 'all input accept port',
        firewall1_a6: 'Default Limited Port',
        firewall1_a7: '17951,default limit ssh access',
        firewall1_a8: 'limit http access',
        firewall1_a9: 'default not to limit http access',
        firewall1_a10: 'limit https access',
        firewall1_a11: 'default not to limit https access',
        firewall2_a1: 'Add rule',
        firewall2_a2: 'direction',
        firewall2_a3: 'User type',
        firewall2_a4: 'Protocol',
        firewall2_a5: 'Port',
        firewall2_a6: 'Remote Addr',
        firewall2_a7: 'Rule',
        firewall2_a8: 'Permit',
        firewall2_a9: 'Limit',
        firewall2_a10: 'ip Address',
        firewall2_a11: 'In',
        firewall2_a12: 'Out',
        // 系统配置   网络配置
        network1: 'Network setting',
        network2: 'Network proxy',
        network3: 'Network testing',

        network1_a1: 'NetMask(v4)',
        network1_a5: 'IP Address(v4)',
        network1_a5_v6: 'IP Address(v6)',

        network1_a6: 'Net Work',
        network1_a2: 'GateWay(v4)',
        network1_a2_v6: 'GateWay(v6)',

        network1_aa_v6: 'Enable(v6)',






        network1_a3: 'DNS1',
        network1_a4: 'DNS2',
        network2_a1: 'Proxy server',
        network2_a2: 'Proxy port',
        network2_a3: 'Proxy user',
        network2_a4: 'Proxy password',
        network3_a1: 'Program Type',
        network3_a2: 'Host or IP',
        network3_a3: 'Analytic Type',
        network3_a4: 'Run Result',
        network3_a5: 'Run',
        network3_a6: 'Test port',
        network3_a7: 'Test number',
        // 系统配置   网关认证配置
        autu1: 'Auth By SMTP',
        autu2: 'Auth By POP',
        autu3: 'Auth By Imap',
        autu4: 'Auth By AD',
        autu5: 'Auth test',
        autu6: 'Auth control',
        autu1_a1: 'Check this to Enable SMTP auth',
        autu1_a7: 'NTLM just use half email to auth',
        autu1_a2: 'SMTP Server',
        autu1_a3: 'Multiple authentication addresses can be configured,',
        autu1_a4: 'SMTP Server Port',
        autu1_a5: 'EHLO hostname',
        autu1_a6: 'SMTP auth',
        autu2_a1: 'Check this to Enable POP3 auth',
        autu2_a2: 'POP3 Server',
        autu2_a3: 'POP3 Port',
        autu2_a4: 'SSL',
        autu3_a1: 'Check this to Enable IPAM auth',
        autu3_a2: 'IMAP Server',
        autu3_a3: 'IMAP Port',
        autu4_a1: 'Check this to Enable LDAP auth',
        autu4_a2: 'LDAP Server',
        autu4_a3: 'LDAP Port',
        autu4_a4: 'LD Base',
        autu4_a5: 'Bind DN',
        autu4_a6: 'PASSWORD',
        autu5_a1: 'The test tests the authentication methods that have been enabled',
        autu5_a2: 'User name',
        autu5_a3: 'password',
        autu5_a4: 'begin to',
        autu6_a1: 'Add auth trust ip',
        autu6_a2: 'Fail cycle',
        autu6_a3: 'minute',
        autu6_a4: 'Fail num',
        autu6_a5: ' Set the auth fail cycle and fail num from the same ipaddress',
        // 系统配置   基本配置
        base1: 'MTA',
        base2: 'Default Domain',
        base3: 'Relay Domain',
        base4: 'Local Domain',
        base5: 'Route',
        base6: 'TLS',
        base7: 'Time',
        base8: 'ip access control',
        base9: 'License manage',
        base10: 'Certficate manage',
        base1_a1: 'current mynetworks',
        base1_a2: 'input mynetworks ip',
        base1_a3: 'select',
        base1_a4: 'Add Trust IP',
        base1_a4_edit: 'Edit Trust IP',
        base1_a5: 'Setdomain Name',
        base1_a6: 'current mydomain',
        base1_a7: 'input mydomain',
        base1_a8: 'current myhostname',
        base1_a9: 'input myhostname',
        base1_a10: ' must be added to the outgoing SMTP IP',
        base1_a11: 'select to configure mynetworks item',
        base1_a12: 'The only default domain name in the system',
        base1_a13: 'SMTP HELO hostname',
        base2_a1: 'current filterdomain',
        base2_a2: 'domain',
        base2_a3: 'current authdomain',
        base3_a1: 'Configure Rela Domain',
        base3_a3: 'Add Rela Domain',

        base3_a2: 'A relay domain name is allowed to be relayed through an anti-garbage gateway',
        base4_a1: 'Configure Local Domain',
        base4_a3: 'Add Local Domain',
        base4_a2: 'Anti-spam will treat all domain names in this list as if they were local',
        base5_a1: 'Set Routs',
        base5_a6: 'Add Rout',
        base5_a2: 'Set Routs,The gateway to the mail server must be set',
        base5_a3: 'Route address',
        base5_a3_sender: 'sender address',
        base5_a4: 'Route target address',
        base5_a5: 'Route port',
        base5_a7: 'Supoort two or more address,use comma to spilt',
        base5_a8: 'Routing patterns',
        base5_a9: 'Edit Routing',

        base6_a1: 'Set TLS',
        base6_a5: 'Add TLS',

        base6_a2: 'Set TLS for the destination domain',
        base6_a3: 'TLS Address',
        base6_a4: 'TLS type',
        base7_a1: 'System time',
        base7_a2: 'Set manual',
        base7_a3: 'NTP server',
        base7_a4: 'Set sys time',
        base7_a5: 'Rsync',
        base8_a1: 'enable',
        base8_a2: 'After Enable,just assigned IP can access',
        base8_a3: 'access ip range',
        base8_a4: 'IP can set the IP segment and the final IP, separated by commas',
        base8_a5: 'Enable Super Prive IP range',
        base8_a6: 'super priv IP Range',
        base8_a7: 'Super Ip can congiure network,shutdown,restart system',
        base8_a8: 'Max login error',
        base8_a9: 'Manager will disabled for a period time when login error exceed the set',
        base8_a10: 'Login error limit',
        base8_a11: 'The limit time of manager login error,unit is second',
        base9_a1: 'License expiredate',
        base9_a2: 'MAC Address',
        base9_a3: 'license key',
        base9_a4: 'reister',
        base10_a1: 'UpLoad certficate',
        base10_a2: 'Rrbuild certificate',
        base10_a3: 'Support the certficate type: crt pem or pfx',
        base10_a4: 'Common Name',
        base10_a5: 'Issuer',
        base10_a6: 'Certificate create time',
        base10_a7: 'Certificate expire time',
        base10_a8: 'company name',
        base10_a9: ' department ',
        base10_a10: 'city',
        base10_a11: 'Province ',
        base10_a12: 'Country ',
        base10_a13: '2 letter code,such as CN US',
        base10_a14: 'year',
        base10_a15: 'Certificate format',
        base10_a16: 'Certificate File',
        base10_pass: 'Certificate Pass',
        base10_a17: 'Certificate key',
        base10_a18: 'Certificate Profile',
        // 垃圾病毒   隔离管理通知
        notifyman1: 'Notify param',
        notifyman2: 'Exclude user',
        notifyman3: 'Appoint user',
        notifyman4: 'Alias user',
        notify1: 'Default domain',
        notify2: 'webaddr',
        notify3: 'send time',
        notify4: 'save days',
        notify5: 'Notify policy',
        notify6: 'enable',
        notify7: 'domain or email address',
        notify8: 'Email',
        notify9: 'Alias',
        notify10: 'Add exclude user',
        notify11: 'Add appoint user',
        notify12: 'Add alias user',
        notify13: 'Custom  notific',
        notify13_add: 'Custom add',
        notify13_edit: 'Custom Edit',
        notify13_policy: 'Notific policy',
        notify13_notice_time: "Notice time",

        notify_state1: 'Set the sender domain of notify email',
        notify_state2: 'webaddr such as http://ip:port or http://domain:port',
        notify_state3: 'set which hour to send notification,such as 8 or 8:16,8:16 mean send at 8 and 16',
        notify_state4: 'days assigned for max life duration for notification',
        notify_state5: 'Set send notify to appoint users or do not send to exclude users,default all send',
        notify_state6: 'Enable send notification or not',
        // 审核区邮件
        auditlist: 'audit list',
        auditlist1: 'audit state',
        // 审核策略
        save_a: 'save',
        save_b: 'cancel',
        audit: 'Audit flow',
        audit1: 'Audit name',
        audit2: 'Audit manage',
        audit3: 'Edit flow',
        audit4: 'Edit policy',
        audit5: 'Add audit flow',
        audit6: 'Operation',
        audit7: 'Policy audit rule',
        audit8: 'Audit policy is to combine the units in and or non',

        // 延迟投递区
        defer: 'Defer list',
        defer1: 'Defer time',
        defer2: 'status',
        defer3: 'wait send',
        defer4: 'has send',
        defer5: 'cancel send',
        // 管理日志
        manage01: '	Manage log',
        manage: 'Query manage log',
        manage1: 'time',
        manage2: 'admin',
        manage3: 'ip',
        manage4: 'action',
        // 异常账号
        qing_a: 'Confirm clear？',
        qing_a1: 'Clear success',
        qing_a2: 'Cleared off',
        removeabus: 'Remove user',
        abnuser: 'Abnormal user',
        weakp: 'Weak pass email',
        weakp1: 'weak pass type',

        contab: 'Content abuse',
        expabe: 'Exprot abuse email',
        currente: 'Current host abuse email',
        claerwu: 'Clear Weak user',
        claerwu1: 'Exprot Weakpass email',
        claerwu2: 'Current host Weakpass email',
        clearcon: 'Clear Content abuse',
        clearcon1: 'Exprot Content abuse',
        shuo1: 'The following emails may be abnormal,please confirm and notice them to change password if is true!',
        shuo2: 'The following emails password is too weak,please notice them to change password!',
        shuo3: 'The following emails is abused by contet,please confirm and notice them to change password if is true!',
        addt: 'add time',
        // 当前SMTP连接
        smtpc: 'Cur smtp connect',
        xuhao: 'Order',
        ip: 'IP',
        connect: 'Connections',
        xuhao1: '  The following ip is connecting with the system!',
        xuhao2: ' Cur total connect ip num',
        xuhao3: 'Cur total connections',
        // 当前队列
        Queue: 'Queue management',
        clearAll: 'Clear all queue',
        clearDef: 'Clear deferred queue',
        resAll: 'Resend all queue',
        query: 'Query queue',
        chongFa: 'resend',
        sender: 'Sender',
        recipient: 'recipient',
        Queueid: 'Queue ID',
        Queuetotal: 'Queue total counts',
        Queuetotal1: 'Red queue is sending and black queue is failed,wait for resend',
        ressequ: 'Resend select queue',
        ressequ1: 'Delete select queue',
        kuaifa: 'Are you sure to resend one queue quickly?',
        kuaifa1: 'successful',
        kuaifa2: 'Cancel the back',
        kuaifa3: 'Empty the success',
        kuaifa4: 'find success',
        kuaifa5: 'Cancel the lookup',

        qing1: 'Are you sure to clear all queue?',
        qing2: 'Are you sure to clear all deferred queue?',
        qing3: 'Are you sure to resend all queue?',
        qing4: 'Are you sure to resend all the select queue',
        qing5: 'Are you sure to delete all the select queue',
        qing6: 'Please select at least one queue',
        sand4_1: 'Subject',
        sand4_2: 'Sender',
        sand4_3: 'Recipient',
        sand4_4: 'cluster host',
        sand4_5: 'MTA',
        // 
    }

}